<template>
    <!-- <header class="p-2 mb-3 border-bottom bg-light">
        <div class="container-fluid">
            <div
                class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start"
    >-->
    <nav class="navbar navbar-expand-lg navbar-light mb-10 p-1" :class="( ' bg-' + (!G.isTheme(theme) || (theme === 'light' || theme === 'none') ? 'light text-dark' : `${theme} text-light`) )">
        <div class="container-fluid">
            <!-- <a
                class="p-1"
                :class="mobileView ? 'navbar-toggler cursor-pointer' : 'navbar-brand1 cursor-pointer'"
                type="button"
                :data-bs-toggle="mobileView ? 'offcanvas' : 'left-sidebar'"
                :data-bs-target="mobileView ? '.left-sidebar' : '.left-sidebar'"
                :aria-controls="mobileView ? 'left-sidebar' : 'left-sidebar'"
                aria-expanded="false"
                @click="setMini($event)"
            > -->
                <!-- <i class="fas p-0 fs-5 p-2" :class="(mini ? 'fa-chevron-right' : 'fa-chevron-left') + ' ' + (theme === 'light' || theme === 'none' ? 'text-dark' : `text-light`)"></i> -->
                <!-- <i class="navbar-toggler-icon"></i> -->

                <!-- <i class="fas fa-bars fs-4 " :class="theme === 'light' || theme === 'none' ? 'text-dark' : `text-light`"></i> -->

                <!-- <div class="ms-aside-toggler ms-toggler pl-0" data-target="#ms-side-nav" data-toggle="slideLeft">
                    <span class="ms-toggler-bar" :class="theme === 'light' || theme === 'none' ? 'bg-dark' : `bg-light`"></span>
                    <span class="ms-toggler-bar" :class="theme === 'light' || theme === 'none' ? 'bg-dark' : `bg-light`"></span>
                    <span class="ms-toggler-bar" :class="theme === 'light' || theme === 'none' ? 'bg-dark' : `bg-light`"></span>
                </div> -->
            <!-- </a> -->

            <NavbarButton :theme="theme" />


            <!-- <a class="navbar-brand cursor-pointer" @click="setMini">
                <i class="fas fa-bars small text-muted me-2 d-none d-sm-inline-block"></i>
                {{G.projectName}}
            </a> -->
            <!-- <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target=".offcanvasSidebar"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                aria-controls="navbarSupportedContent"
                <span class="fas fa-sitemap"></span>
            </button> -->
            <button
                class="navbar-toggler"
                :class="!G.isTheme(theme) || (theme === 'light' || theme === 'none') ? 'text-dark' : `text-light`"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <!-- <span class="navbar-toggler-icon"></span> -->
                <i class="fas fa-bars fs-1" :class="theme === 'light' || theme === 'none' ? 'text-dark' : `text-light`"></i>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <!-- <li>
                        <a
                            :href="`https://${G.main_host}`"
                            target="blank"
                            class="nav-link text-uppercase mx-3"
                            :class="!G.isTheme(theme) || (theme === 'light' || theme === 'none') ? 'text-dark' : `text-light`"
                        >{{G.main_host}}</a>
                    </li> -->
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            :class="!G.isTheme(theme) || (theme === 'light' || theme === 'none') ? 'text-dark' : `text-light`"
                            href="/"
                        >
                            <i class="fas fa-home me-1"></i>Ana səhifə
                        </a>
                    </li>
                    <!-- <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            :class="theme === 'light' || theme === 'none' ? 'text-dark' : `text-light`"
                            href="#"
                            id="dropdown05"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >Alt menyu</a>
                        <ul class="dropdown-menu" aria-labelledby="dropdown05">
                            <li>
                                <a class="dropdown-item" href="#">
                                    <i class="fas fa-download me-2"></i> Menu 1
                                </a>
                            </li>
                        </ul>
                    </li> -->

                    <!-- <router-link :to="{ name: 'about', params: { id: 2 } }" class="nav-link link-dark px-2">Profilim</router-link>
                    <router-link :to="'/about/' +  2 " class="nav-link link-dark px-2">Profilim</router-link> -->

                    <!-- <li class="nav-item">
                        <a href="/profile" class="nav-link link-dark">
                            <i class="fas fa-user me-1"></i>Profilim
                        </a>
                    </li> -->

                </ul>

                <!-- <form class="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3">
                    <div class="input-group">
                        <button tpye="submit" class="btn btn-primary">
                            <i class="fas fa-search"></i>
                        </button>
                        <input
                            type="search"
                            class="form-control"
                            placeholder="Axtar..."
                            aria-label="Search"
                        />
                    </div>
                </form> -->

                <div class="navbar-nav text-nowrap d-flex-sm align-items-sm-center">
                    <!-- <a
                        class="nav-link me-3"
                        :class="theme === 'light' || theme === 'none' ? 'text-dark' : `text-light`"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasNavbar"
                        aria-controls="offcanvasNavbar"
                        aria-expanded="false"
                    >
                        <i class="fas fa-cogs"></i>
                    </a> -->

                    <!-- <div class="nav-item dropdown">
                        <a
                            href="#"
                            class="nav-link dropdown-toggle"
                            :class="theme === 'light' || theme === 'none' ? 'text-dark' : `text-light`"
                            id="dropdownUser1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {{users && users.username}}
                            <img
                                :src="users.image"
                                alt="user"
                                class="rounded-circle"
                                width="32"
                                height="32"
                            />
                        </a>
                        <ul
                            class="dropdown-menu dropdown-menu-sm-end"
                            aria-labelledby="dropdownUser1"
                        >
                            <li>
                                <a class="dropdown-item" href="#">
                                    <i class="fas fa-cog me-1"></i>Sazlamalar
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="/profile">
                                    <i class="fas fa-user me-1"></i>Profilim
                                </a>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <router-link class="dropdown-item" :to="{name: 'login'}">
                                    <i class="fas fa-sign-out-alt me-1"></i>Çıxış
                                </router-link>
                            </li>
                        </ul>
                    </div> -->

                    <div class="dropdown">
                        <a class="btn btn-primary1 text-light dropdown-toggle border1" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                            <span v-if="G.warningsListRef.value.length" class="position-absolute spinner-grow spinner-grow-sm top-21 start-501 translate-middle p-1 bg-danger1 rounded-circle" style="background-color: #afdba3; top: 8px; left: 30px; --bs-spinner-animation-speed: 2s; --bs-spinner-width: .6rem; --bs-spinner-height: .6rem;">
                                <span class="visually-hidden">New</span>
                            </span>
                            <i class="far fa-bell"></i>
                        </a>
                        <div class="dropdown-menu p-0 dropdown-menu-end" style="width: 350px; max-width: 350px; max-height: 400px; overflow-y: auto;">

                            <!-- <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            {{ TR.warning }}
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            limit overflow.
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                            <div class="list-group">
                                <template v-for="(item, index) in G.warningsListRef.value" :key="index">
                                    <a target="_blank" :href="item.link" class="list-group-item list-group-item-action w-100 text-wrap" aria-current="true">
                                        <!-- <div v-html="item.title"></div> -->
                                        <div class="d-flex w-100 justify-content-between">
                                            <h5 class="mb-1 fw-bold">{{ item.title }}</h5>
                                            <small>{{ item.date }}</small>
                                        </div>
                                        <!-- <p class="mb-1 w-100">{{ item.subtitle }}</p> -->
                                        <small>{{ item.subtitle }}</small>
                                    </a>
                                </template>
                            </div>

                        </div>
                    </div>

                    <div class="mb-sm-0 mb-3 d-flex align-items-center text-secondary1">
                        <span class="ms-sm-2 order-2 order-sm-1">{{users && users.firstname + ' ' + users.lastname}}</span>
                        <img
                            :src="users.image"
                            class="rounded ms-sm-2 me-2 order-1 order-sm-2"
                            width="24"
                            height="24"
                            alt="user"
                        />
                    </div>


                    <!-- <router-link class="d-flex align-items-center border dropdown-item ms-3" :to="{name: 'login'}"> -->
                    <a class="btn d-flex align-items-center border dropdown-item ms-sm-3 mb-sm-0 mb-3" @click="logout_btn">
                        <i class="fas fa-sign-out-alt me-2"></i>{{TR.logout}}
                    </a>
                    <!-- </router-link> -->
                </div>
            </div>
        </div>
    </nav>

</template>


<script>
    import { ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";

    import { useRouter } from "vue-router";

    import NavbarButton from "@/components/navbar/NavbarButton";

    import { G, ajax } from "@/_common";

    export default {
        name: "NavBar",
        components: {
            NavbarButton,
        },
        props: {
            theme: {
                type: String,
                default: 'light'
            },
        },
        setup() {
            const store = useStore();
            const router = useRouter();

            const TR = ref();

            const users = ref(G.token_data());
            const mini = ref();

            // if( G.userImage.value != '' ){
            //     users.value.image = G.userImage.value;
            // }

            watchEffect(() => {
                TR.value = store.getTranslation();
                mini.value = store.getSidebarStatus();
            });

            const logout_btn =  async () => {
                await ajax({
                    url: store.getLogout(),
                    method: "get",
                    success: async () => {
                        router.replace({ name: 'login' });
                    },
                });
            };

            return { G, TR, mini, users, logout_btn };
        },
    };
</script>


<style lang="scss" scoped>
.accordion-body {
  text-wrap: wrap;
}
</style>